<template>
  <div class="home">
      <VireedChatProject></VireedChatProject>
  </div>
</template>

<script>
import VireedChatProject from '@/components/VireedChatProject.vue';
export default {
  name: 'chat',
  components: {
    VireedChatProject
  }
}
</script>